export default {
    baseUrl: 'https://app.tiller.orisma.com/',
    apiUrl: "https://api.tiller.orisma.com/internal/v1/",
    websocketUrl: "https://wss.tiller.orisma.com"
};